import {
  Component,
  ContentChild,
  DestroyRef,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output,
  QueryList,
  signal,
  TemplateRef,
  viewChild,
  ViewChildren,
} from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { ModalService } from '@app/_services';
import { delay, distinctUntilChanged } from 'rxjs';

@Component({
    selector: 'modal-content',
    template: '@if (!loading) { <ng-content></ng-content> }' +
  '@if (loading) { <loader></loader> }',
    standalone: false
})
export class ModalContentComponent {
  @Input() public id: string;
  @Input() public loading: boolean = false;
  @ContentChild(TemplateRef) public templateRef: TemplateRef<any>;
}

@Component({
    selector: 'htm-modal',
    templateUrl: './modal.template.html',
    styleUrls: ['./modal.styles.scss'],
    standalone: false
})
export class ModalComponent implements OnInit {
  public opened = signal(false);
  private state$ = toObservable(this.opened);

  @Input() public id: string;
  @Input() public blockModal: boolean = true;
  @Input() public systemModal: boolean = false;
    @Input() public modalTitle: string = '';
  @Input() public titleExists: boolean = true;
  @Input() public topAction: boolean = true;
  @Input() public bottomAction: boolean = true;
  @Input() public size: string = 'default';
  @Input() public reloadOnClose: boolean = false;
  @Input() public initializeAsOpen: boolean = false;
  @Output() public onClose: EventEmitter<any> = new EventEmitter();
  @ViewChildren('modalContent') public contents: QueryList<any>;
  @ContentChild(TemplateRef) public templateRef: TemplateRef<any>;
  titleRef = viewChild<ElementRef<HTMLElement>>('titleRef');
  private element: any;

  constructor(private elem: ElementRef, private modalService: ModalService, private destroyRef: DestroyRef) {
    this.element = elem.nativeElement;
  }

  @HostBinding('class') get hostClasses(): string {
    const classes = [];
    classes.push(this.opened() ? '' : 'modal-hidden');
    classes.push(`size-${this.size}`);
    return classes.join(' ');
  }

  @HostListener('document:keydown', ['$event'])
  public onKeyDownHandler(event: KeyboardEvent) {
    if (!this.systemModal && event.key === 'Escape') {
      this.stateChange(false);
    }
  }

  public ngOnInit() {
    this.modalService.add(this);
    if (this.initializeAsOpen) this.stateChange(true);
    this.state$.pipe(distinctUntilChanged(),delay(50), takeUntilDestroyed(this.destroyRef)).subscribe(val => {
      if (val) {
        this.titleRef()?.nativeElement?.focus();
      }
    });
  }

  public ngOnDestroy(): void {
    this.modalService.remove(this.id);
  }

  public stateChange(state: boolean): void {
    const isOpened = this.modalService.modalOpened()[this.id];
    this.modalService.modalOpened.update((prev) => ({...prev, [this.id]: state}));
    if (this.opened() && !state && this.reloadOnClose) {
      window.location.reload();
    }
    this.opened.set(state);
    if (isOpened && !state) {
      this.onClose.emit(true);
    }
  }
}
